import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, ListItemText, MenuItem, Select } from '@mui/material';
import { PanNumber } from 'models/pan-number';

type PanNumberSelectProps = {
    panNumbers: PanNumber[];
    selectedPanNumber: string | undefined;
    onPanNumberChange: (panNumber: PanNumber) => void;
};

const PanNumberSelect: FC<PanNumberSelectProps> = ({ panNumbers, selectedPanNumber, onPanNumberChange }) => {
    const { t: translate } = useTranslation(['orders']);

    return (
        <FormControl fullWidth size="small">
            <InputLabel required>{translate('orders:SELECT_PAN_NUMBER')}</InputLabel>
            <Select
                value={selectedPanNumber || ''}
                label={translate('orders:SELECT_PAN_NUMBER')}
                onChange={(event) => {
                    const selected = panNumbers.find((panNumber) => panNumber.value === event.target.value);
                    if (selected) onPanNumberChange(selected);
                }}
                renderValue={(value) => {
                    const selected = panNumbers.find((panNumber) => panNumber.value === value);
                    return (
                        <ListItemText
                            primary={selected?.value ?? value}
                            secondary={selected?.description}
                            sx={{ margin: 0 }}
                        />
                    );
                }}
            >
                {panNumbers.map((panNumber) => (
                    <MenuItem key={panNumber._id} value={panNumber.value}>
                        <ListItemText primary={panNumber.value} secondary={panNumber.description} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default PanNumberSelect;
